module.exports = __webpack_public_path__ + "img/q2.7b4f57dd.png";